import React, { Component } from 'react';
import { Table, message, Popconfirm, Select, Button } from 'antd';
import './style.less';
import send from '../../util/request';
import CpProductChoose from '../../components/CpProductChoose';

// const { Option } = Select;
const years = [2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].sort().map(item => ({ label: item, value: item }));
const { localStorage } = window;

class annualPlanOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryList: [],
      productList: [],
      productObj: {},
      visible: false,
      currentProductList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  }
  columns = [
    {
      title: '供应商',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      align: 'center',
      width: 180
    },
    {
      title: '供应商编码',
      dataIndex: 'org_id',
      key: 'org_id',
      align: 'center',
      width: 120
    },
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
      width: 180
    },
    {
      title: '商品编码',
      dataIndex: 'sku_sn',
      key: 'sku_sn',
      align: 'center',
      width: 120
    },
    {
      title: '等级',
      dataIndex: 'level',
      key: 'level',
      align: 'center',
    },
    {
      title: '产地',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'unit_desc',
      key: 'unit_desc',
      align: 'center',
      width: 120
    },
    {
      title: '单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      render: (text, record) => (
        <Popconfirm
          title="是否要移除?"
          onConfirm={() => this.handleDelete(record, 1)}
          okText="确定"
          cancelText="取消">
          <a style={{ color: '#D60505' }}>移除</a>
        </Popconfirm>
      ),
    },
  ]

  componentDidMount() {
    const account = localStorage.getItem('account');
    const companyId = localStorage.getItem('companyId');
    const companyName = localStorage.getItem('companyName');
    this.setState({
      account,
      companyId,
      companyName
    });
    this.getCategory();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  getCategory = () => {
    send({
      url: '/ipp/product/category',
      method: 'GET',
    }).then(res => {
      if (res.data.code === 0) {
        const data = res.data.data;
        const list = data.list;
        const tree = [];
        list.forEach((item) => {
          let category = {
            id: item.id,
            name: item.name,
            title: item.name,
            value: item.id,
            cat_pid: item.cat_pid,
            children: [],
          };
          item.child &&
            item.child.forEach((subItem) => {
              category.children.push({
                id: subItem.id,
                name: subItem.name,
                title: subItem.name,
                value: subItem.id,
                cat_pid: subItem.cat_pid,
              });
            });
          tree.push(category);
        });
        this.setState({
          categoryList: tree,
        });
      }
    });
  }
  handleDelete = (record, type) => {
    let { selectedRowKeys, productObj, productList } = this.state;
    let array = [];
    if (type === 1) {
      array = [record.norms_id];
    } else {
      array = selectedRowKeys;
    }

    array.forEach(item => {
      delete productObj[item];
    });
    productList = Object.values(productObj);
    this.setState({
      productObj,
      productList,
      total: productList.length,
    }, () => {
      this.handleProductList();
    });
  }
  selectProduct = () => {
    this.setState({
      visible: true
    });
  }
  hideModal = () => {
    this.setState({ visible: false });
  }
  submitModal = (submitObj) => {
    let { productObj, productList } = this.state;
    productObj = Object.assign({}, productObj, submitObj);
    productList = Object.values(productObj);
    this.setState({
      productObj,
      productList,
      total: productList.length
    }, () => {
      this.handleProductList();
    });

    this.setState({ visible: false });
  }
  handleProductList = () => {
    const { currentPage, pageSize, productList } = this.state;
    let start = (currentPage - 1) * pageSize;
    let end = start + pageSize;
    let currentProductList = productList.slice(start, end);
    this.setState({
      currentProductList
    });
  }
  valueChanged = (value) => {
    this.setState({
      year: value
    });
  }
  submitPlan = () => {
    const { productList, year } = this.state;
    if (!year) {
      message.info('请先选择计划年份');
      return;
    }
    if (!productList.length) {
      message.info('请先选择商品');
      return;
    }

    let products = [];
    productList.forEach(obj => {
      products.push({
        year,//年度
        supplier_id: obj.org_id,//供应商id
        spu_id: obj.spu_id,//商品spu_id
        sale_id: obj.sale_id,//商品售卖id
        sale_name: obj.sale_name,//商品售卖名称
        sale_image: "",//商品图片
        sku_no: obj.sku_sn,//商品编码
        sku_unit: obj.unit,//商品单位
        sku_unit_desc: obj.unit_desc,//商品规格
        sku_group_type: obj.is_group,//是否是集团商品：1-集团内 2-外采
        sku_level: obj.level,//级别
        sku_place: obj.place,//产地
      });
    });

    send({
      url: '/ipp/order-plan-year/insert',
      method: 'POST',
      data: {
        products
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        this.props.history.go(-1);
      } else {
        message.error(res.data.msg);
      }
    });

  }
  cancle = () => {
    this.props.history.go(-1);
  }
  render() {
    const { account, companyId, companyName, visible, currentProductList, currentPage, pageSize, total, selectedRowKeys, isBatchAdd } = this.state;

    const chooseCheck = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          isBatchAdd: selectedRowKeys.length > 0 ? true : false,
          addList: selectedRows,
          selectedRowKeys,
        });
      },
    };

    return (
      <div className="annual-plan-order-detail">
        <div>
          <span className="title">新建年度计划：</span>
          <span className="company-name">{companyName}公司（公司代码：{companyId}）操作账号：{account}</span>
        </div>
        <div style={{ margin: '20px 0px' }}>
          <div>
            <span>计划年份：</span>
            <Select placeholder='请选择年份' onChange={(value) => this.valueChanged(value)} options={years}>
              {/* {
                years.sort().map(obj => {
                  return <Option key={obj} value={obj}>{obj}年</Option>;
                })
              } */}
            </Select>
          </div>
          <div style={{ marginTop: '10px' }}>
            <span>计划商品：</span>
            <Button type="primary" style={{ marginTop: '10px' }} onClick={this.selectProduct}>选择商品</Button>
          </div>
        </div>
        <div style={{ textAlign: 'right', margin: '0 20px 10px 0' }}>
          <Button disabled={!isBatchAdd} type="primary" style={{ marginTop: '10px' }} onClick={this.handleDelete}>批量移除</Button>
        </div>
        <div>
          <Table
            rowKey={record => record.norms_id}
            columns={this.columns}
            dataSource={currentProductList}
            rowSelection={chooseCheck}
            scroll={{ x: 1000 }}
            pagination={{
              pageSize: pageSize,
              total: total,
              current: currentPage,
              onChange: (currentPage, pageSize) => {
                this.setState(
                  {
                    currentPage,
                    pageSize,
                  },
                  () => {
                    this.handleProductList();
                  }
                );
              },
            }}
          />
        </div>
        <div style={{ margin: '40px 0px', textAlign: 'center' }}>
          <Button type="primary" onClick={this.submitPlan}>生成年度计划</Button>
          <Button style={{ marginLeft: '20px' }} onClick={this.cancle}>取消</Button>
        </div>
        {
          visible ? <CpProductChoose
            categoryList={this.state.categoryList}
            record={this.record}
            hideModal={this.hideModal}
            submitModal={this.submitModal}>
          </CpProductChoose> : null
        }
      </div>
    );
  }
}
export default annualPlanOrderDetail;